import React from "react";
import NewsComponent from "./NewsComponent";
import AppointmentsComponent from "./AppointmentsComponent";
import ContentBlockquote from './StateLessComponents/ContentBlockquote';
import { render } from '@testing-library/react';
import fakeContentService from '../services/fakeContentService';

class HomeComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            content: ''
        }
    }

    async componentDidMount(){
        const content = await fakeContentService.getHomeContent();

        this.setState({content})
    }

    render(){
        const {content} = this.state;

        return (
            <div>
                <h1 className={"kgnsf-header"}>Willkommen bei den Neustadtfunken</h1>

                <img alt="" className={"img-fluid kgnsf-img"} src={"images/Titelbild.jpg"} />

                <div className={"row"}>
                    <div className={"col-lg-8 col-md-8 col-sm-12 col-xs-12"}>
                        <ContentBlockquote content={content}></ContentBlockquote>
                        {/* <NewsComponent /> */}
                    </div>
                    <div className={"col-lg-4 col-md-4 col-sm-12 col-xs-12"}>
                        <AppointmentsComponent />
                    </div>
                </div>
            </div>
        );
    }
};

export default HomeComponent;